/**
 *  @function initLivechatWrapper
 *  Toggles livechat-wrapper--active on #livechat-wrapper based on scroll position.
 *  The element is injected asynchronously by a third-party livechat widget, so we
 *  wait for it to appear in the DOM before attaching the scroll listener.
 */
(function () {
  var pageHeight = window.innerHeight;

  function checkVisible(el) {
    window.requestAnimationFrame(function () {
      if (window.scrollY > pageHeight) {
        el.classList.add('livechat-wrapper--active');
      } else {
        el.classList.remove('livechat-wrapper--active');
      }
    });
  }

  function bind(el) {
    checkVisible(el);
    window.addEventListener('scroll', function () {
      checkVisible(el);
    });
  }

  var existing = document.getElementById('livechat-wrapper');
  if (existing) {
    bind(existing);
    return;
  }

  var observer = new MutationObserver(function () {
    var el = document.getElementById('livechat-wrapper');
    if (el) {
      observer.disconnect();
      bind(el);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
